import { render } from "./MoldResume.vue?vue&type=template&id=21f926b0&scoped=true"
import script from "./MoldResume.vue?vue&type=script&lang=js"
export * from "./MoldResume.vue?vue&type=script&lang=js"

import "./MoldResume.vue?vue&type=style&index=0&id=21f926b0&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f926b0"]])

export default __exports__